module.exports = __webpack_public_path__ + "media/images/metronic/social/linkedin-5d84286efefe54119d172f6a875614bf.png";